import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=2a5f7d34"
import script from "./Student.vue?vue&type=script&lang=ts"
export * from "./Student.vue?vue&type=script&lang=ts"
import style0 from "./Student.vue?vue&type=style&index=0&id=2a5f7d34&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports